import Buger from '@npc/buger-sdk'
import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useRouterState } from '@tanstack/react-router'
import { useBugReporterConfig } from './bug-reports'

import { api } from './api'

export function BugReportLauncher() {
  const pathname = useRouterState({ select: state => state.location.pathname })
  const projectId = pathname.match(/^\/projects\/([0-9a-f-]{36})(?:\/|$)/)?.[1]
  const projectConfig = useBugReporterConfig(projectId)
  const config = useQuery({
    queryKey: ['platform-bug-reporter'],
    queryFn: async () => {
      const { data, error } = await api.GET('/public/bug-reporter')
      if (error) throw new Error('Platform feedback configuration unavailable')
      return data
    },
    retry: false,
    refetchInterval: 60_000,
  })
  const selected = projectId ? projectConfig.data : config.data

  useEffect(() => {
    const projectKey = selected?.project_key
    if (!projectKey || !selected?.enabled) return
    Buger.destroy()
    Buger.init({ projectKey, endpoint: location.origin, release: config.data?.release ?? '', myReportsUrl: `/api/v1/bug-reports?mine=true${projectId ? '&project_id='+projectId : ''}` })
    return () => Buger.destroy()
  }, [selected?.enabled, selected?.project_key, config.data?.release])

  return null
}
